<app-header [user]="user"></app-header>
<div class="company_title">Select Company</div>
<a [href]="companyUrls[company.id]" class="company_item"
     *ngFor="let company of companies"
>
  <div class="ico_text">{{company.attributes.name[0]}}</div>
  <div class="company_item_name">{{company.attributes.name}}</div>
  <div class="ico_login_arrow"></div>
</a>
